import ProductPackshot from './Packshot';
export { ProductPackshot };